// theme sabse pehle lagao taaki jhilmil na ho
try {
  const t = localStorage.getItem("it_theme") || "light";
  if (t === "light") document.documentElement.classList.add("light");
} catch (e) {}

import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import "@/index.css";
import App from "@/App";

import { applyTheme, getTheme } from "@/lib/api";
applyTheme(getTheme());

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "rgba(10, 10, 16, 0.92)",
            border: "1px solid rgba(255, 255, 255, 0.08)",
            color: "#fff",
            backdropFilter: "blur(16px)",
            fontFamily: "'Manrope', sans-serif",
          },
        }}
      />
    </QueryClientProvider>
  </React.StrictMode>,
);

// PWA — register service worker after page load
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  var _itReloading = false;
  var _itRunning = (function () {
    try {
      var el = document.querySelector('script[src*="/static/js/main."]');
      return el ? el.src.split("/").pop().split("?")[0] : "";
    } catch (e) { return ""; }
  })();
  function _itShowUpdateBar() {
    if (document.getElementById("it-update-bar")) return;
    var bar = document.createElement("div");
    bar.id = "it-update-bar";
    bar.style.cssText = "position:fixed;left:0;right:0;top:0;z-index:2147483647;display:flex;align-items:center;justify-content:center;gap:12px;padding:10px 16px;background:#0b7285;color:#fff;font:600 14px/1.3 Manrope,system-ui,sans-serif;box-shadow:0 2px 14px rgba(0,0,0,.35)";
    var msg = document.createElement("span");
    msg.textContent = "A new version is available.";
    var btn = document.createElement("button");
    btn.type = "button";
    btn.textContent = "Update now";
    btn.style.cssText = "background:#fff;color:#0b7285;border:0;border-radius:8px;padding:7px 18px;font:700 13px Manrope,system-ui,sans-serif;cursor:pointer";
    btn.onclick = function () { _itReloading = true; window.location.reload(); };
    bar.appendChild(msg);
    bar.appendChild(btn);
    (document.body || document.documentElement).appendChild(bar);
  }
  function _itCheck() {
    fetch("/asset-manifest.json?t=" + Date.now(), { cache: "no-store" }).then(function (r) {
      return r.ok ? r.json() : null;
    }).then(function (mani) {
      if (!mani || !mani.files) return;
      var latest = String(mani.files["main.js"] || "").split("/").pop();
      if (latest && _itRunning && latest !== _itRunning) _itShowUpdateBar();
    }).catch(function () {});
  }
  window.addEventListener("load", function () {
    navigator.serviceWorker.register("/service-worker.js").then(function (reg) {
      try { reg.update(); } catch (e) {}
    }).catch(function () {});
    setInterval(_itCheck, 60000);
    window.addEventListener("focus", _itCheck);
    document.addEventListener("visibilitychange", function () { if (!document.hidden) _itCheck(); });
    setTimeout(_itCheck, 8000);
  });
}

// number wale khaano par mouse-scroll se galti se value na badle
document.addEventListener("wheel", (e) => {
  const el = document.activeElement;
  if (el && el.type === "number" && el === e.target) el.blur();
}, { passive: true });

// Naya version aaya to purani copy atke nahi — chup-chaap refresh
(function () {
  let last = null;
  const check = async () => {
    try {
      const r = await fetch("/index.html", { cache: "no-store" });
      const t = await r.text();
      const m = t.match(/main\.[a-z0-9]+\.js/);
      if (!m) return;
      if (last && last !== m[0] && !document.querySelector(".fixed.inset-0")) {
        var _lb = 0; try { _lb = +localStorage.getItem("__it_build_reload") || 0; } catch (e) {}
        if (Date.now() - _lb > 120000) {
          try { localStorage.setItem("__it_build_reload", String(Date.now())); } catch (e) {}
          window.location.reload();
        }
      }
      last = m[0];
    } catch { /* net nahi to rehne do */ }
  };
  window.__it_build_check = check;
  setTimeout(check, 4000);
  setInterval(check, 5 * 60 * 1000);
  document.addEventListener("visibilitychange", () => { if (!document.hidden) check(); });
})();

// Date wale khaane par kahin bhi click karo -> calendar khud khul jaye
// (warna Chrome me sirf chhote calendar icon par click karna padta hai)
document.addEventListener("click", (e) => {
  const el = e.target;
  if (!el || el.tagName !== "INPUT") return;
  if (el.type !== "date" && el.type !== "month" && el.type !== "datetime-local") return;
  if (el.disabled || el.readOnly) return;
  if (typeof el.showPicker !== "function") return;
  try { el.showPicker(); } catch { /* browser mana kare to type kar lo */ }
}, true);

// PWA install prompt button
(function () {
  try {
    var _itIp;
    window.addEventListener("beforeinstallprompt", function (e) {
      e.preventDefault();
      _itIp = e;
      if (document.getElementById("it-install-btn")) return;
      var b = document.createElement("button");
      b.id = "it-install-btn";
      b.type = "button";
      b.textContent = "Install app";
      b.style.cssText = "position:fixed;right:14px;bottom:14px;z-index:2147483646;padding:10px 16px;border:0;border-radius:12px;background:#00F0FF;color:#001318;font:700 13px Manrope,system-ui,sans-serif;box-shadow:0 6px 20px rgba(0,0,0,.4);cursor:pointer";
      b.onclick = function () { b.remove(); if (_itIp) { _itIp.prompt(); _itIp = null; } };
      (document.body || document.documentElement).appendChild(b);
    });
    window.addEventListener("appinstalled", function () { var x = document.getElementById("it-install-btn"); if (x) x.remove(); });
  } catch (e) {}
})();
